export const RowCount = 4;
export const DefaultTitleFontSize = 44;
export const DefaultDataFontSize = 36;
export const DefaultTimingCellSize = 32;
export const ColumnProps = {
  numberColumnProps: { lg: 2, md: 3, sm: 4, xs: 6 },
  titleColumnProps: { lg: 10, md: 9, sm: 8, xs: 6 },
  timingColumnProps: { lg: 4, md: 4, sm: 5, xs: 6 },
  dataColumnProps: { lg: 8, md: 8, sm: 7, xs: 6 },
};
export const PageHeaderHeight = 92;
export const ListHeaderHeight = 50;
